import { forwardRef } from "react";
import { AvatarContainer, StyledAvatar } from "./Avatar.style.js";
import { AvatarProps, DefaultAvatarProps } from "./Avatar.types.js";
import { LinkedInIcon } from "./components/LinkedInIcon/index.js";
import { StyledStateDot } from "./components/StatusDot/index.js";

const defaultProps: DefaultAvatarProps = {
    shape: "rounded",
    size: "medium",
};

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>((props, ref): JSX.Element => {
    const {
        size,
        className,
        shape,
        dot,
        linkedInStatus,
        border = false,
        ...attributes
    } = {
        ...defaultProps,
        ...props,
    };

    return (
        <AvatarContainer ref={ref} size={size} shape={shape} className={className} border={border}>
            <StyledAvatar {...attributes} size={size} shape={shape} />
            {dot && <StyledStateDot {...dot} size={dot.size || size} />}
            {linkedInStatus && <LinkedInIcon {...linkedInStatus} size={size} />}
        </AvatarContainer>
    );
});
